window.addEventListener('scroll', function() {
  let scrollPosition = window.scrollY || window.pageYOffset;
  let documentHeight = document.documentElement.scrollHeight - window.innerHeight;
  let scrollPercentage = (scrollPosition / documentHeight) * 100;

  if (scrollPercentage > 5 && window._videoWiseLoaded !== true) {
    // Load styles and scripts after user has scrolled more than 5%
    window._videoWiseLoaded = true;
    // Load stylesheet
    let stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = 'https://assets.videowise.com/style.css.gz';
    stylesheet.id = 'videowise-style-css';
    document.head.appendChild(stylesheet);

    // Load client script
    let clientScript = document.createElement('script');
    clientScript.defer = true;
    clientScript.src = 'https://assets.videowise.com/client.js.gz';
    clientScript.id = 'videowise-client-js';
    document.body.appendChild(clientScript);

    // Remove scroll event listener after loading
    window.removeEventListener('scroll', arguments.callee);
  }
});